import React from 'react';

const spinnerLoader = () => <div data-uk-spinner="" />;

export default spinnerLoader;
